import React from 'react';
import { colors, useQueryParams } from '@insurancemenu/imenu-components-lib';
import { AddCircle } from '@insurancemenu/imenu-components-lib/dist/icons';
import { useRootStore } from 'store/rootStore';
import { observer } from 'mobx-react-lite';
import { useHistory } from 'react-router-dom';
import FormModal from '@insurancemenu/imenu-components-lib/dist/components/modals/FormModal';
import { TemplateInputNameStyled, TemplateNameStyled } from './styles';

const AddTemplateVariantModal = observer((): JSX.Element => {
  const {
    addVariantModalStore: {
      loading,
      showAddVariantModal,
      form,
      isModalFormValid,
      duplicatedTemplateName,
      closeAddVariantModal,
      confirmAddVariantModal,
    },
  } = useRootStore();

  const history = useHistory();

  const query = useQueryParams();
  const periodId = query.get('periodId') || '';
  const cartId = query.get('cartId') || '';
  const groupId = query.get('groupId') || '';

  const onAddTemplateVariant = async (): Promise<void> => {
    await confirmAddVariantModal({ periodId, cartId, groupId }, history.push);
  };

  return (
    <FormModal
      show={showAddVariantModal}
      icon={<AddCircle width="5.6rem" color={colors.green[600]} />}
      title="Create New Product Configuration"
      subtitle={
        <p>
          You are about to make a new clone of
          <TemplateNameStyled>{duplicatedTemplateName || 'this'}</TemplateNameStyled> template. Don&apos;t worry, you
          will not be changing the stock product template. Any changes you make will be saved in a new variant and you
          will be able to name it as you wish below. If you don&apos;t want to create a new variant, you can close this
          modal.
        </p>
      }
      loading={loading}
      id="add_variant_modal"
      isFormValid={isModalFormValid}
      onClose={closeAddVariantModal}
      submitButtonText="Add Variant"
      onSubmit={onAddTemplateVariant}
      formContent={
        <>
          <TemplateInputNameStyled
            label="External Product Name"
            name="externalName"
            id="externalName"
            value={form.fields.externalName.value}
            onChange={form.onFieldChange}
            width="95%"
            validationPassed={!form.fields.externalName.unpassedValidationMsg}
            validationMessage={form.fields.externalName.unpassedValidationMsg || ''}
          />
          <TemplateInputNameStyled
            label="Internal Product Name"
            name="internalName"
            id="internalName"
            value={form.fields.internalName.value}
            onChange={form.onFieldChange}
            width="95%"
            validationPassed={!form.fields.internalName.unpassedValidationMsg}
            validationMessage={form.fields.internalName.unpassedValidationMsg || ''}
          />
        </>
      }
    />
  );
});

export default AddTemplateVariantModal;
